import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Models
import mInstallation from 'models/installation';
// Custom
import { getInstallationsAutocomplete } from 'actions';
import { installationDataShape, autoCompleteDataShape } from 'constants/PropTypesShapes';
import AutoCompleteSearchFieldFilter from 'components/filters/AutoCompleteSearchFieldFilter';
import InformationItem from 'components/items/InformationItem';

const InstallationAutoCompleteItem = ({ element, onSelect }) => {
  if (element) {
    const installation = { ...element };

    return (
      <div className="information-item-wrapper">
        <InformationItem
          icon={mInstallation.icon}
          label={<LocalizedMessage id="info.installationDevicesQuantity" values={{ quantity: _size(installation.devices) }} />}
          value={installation.name}
          onClick={() => onSelect(installation)}
        />
      </div>
    );
  }
  return null;
};

InstallationAutoCompleteItem.propTypes = {
  element: installationDataShape,
  onSelect: PropTypes.func,
};

InstallationAutoCompleteItem.defaultProps = {
  element: null,
  onSelect: null,
};

class InstallationAutoCompleteFilter extends React.Component {
  constructor(props) {
    super(props);

    this.handleGetInstallations = this.handleGetInstallations.bind(this);
    this.handleSelectElement = this.handleSelectElement.bind(this);
  }

  // Handlers
  handleGetInstallations(value, page) {
    const { handleGetInstallationsAutocomplete } = this.props;
    // Get default installations list features
    const { defaultParams: { pagination, sort }, autoCompleteFilter } = mInstallation.listFeatures();
    // Define the page to be loaded
    const finalPagination = {
      page: page || pagination.page,
      pageSize: pagination.pageSize,
    };
    // Launch installations loading
    const filter = { ...autoCompleteFilter, value };
    handleGetInstallationsAutocomplete(finalPagination, sort, [filter]);
  }

  handleSelectElement(installation) {
    const { onSelect } = this.props;
    onSelect(installation);
  }

  render() {
    const { installation, installations: { loading, elements, pagination } } = this.props;

    return (
      <AutoCompleteSearchFieldFilter
        label="field.installation"
        element={installation}
        loading={loading}
        elements={elements}
        pagination={pagination}
        elementComp={
          <InstallationAutoCompleteItem />
        }
        onGetElements={this.handleGetInstallations}
        elementDescBuilder={(element) => (element.name)}
        onSelectElement={this.handleSelectElement}
      />
    );
  }
}

InstallationAutoCompleteFilter.propTypes = {
  installation: installationDataShape,
  installations: autoCompleteDataShape.isRequired,
  onSelect: PropTypes.func.isRequired,
  handleGetInstallationsAutocomplete: PropTypes.func.isRequired,
};

InstallationAutoCompleteFilter.defaultProps = {
  installation: null,
};

const mapStateToProps = (state) => ({
  installations: state.autoComplete.installations,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetInstallationsAutocomplete: (pagination, sort, filters) => {
    dispatch(getInstallationsAutocomplete(pagination, sort, filters));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InstallationAutoCompleteFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/main/InstallationAutoCompleteFilter.js